import { RootState } from '../types'

export const getMainSettingSelector = (state: RootState) => state.setting

